import { Spinner } from "reactstrap";
import React from "react";

const SpinnerComponent = ({ styles, spinnerStyles }) => {
  return (
    <>
      <div style={spinnerStyles ? spinnerStyles : {}}>
        <Spinner style={{ color: "#8278f2" }}></Spinner>
      </div>
      <span style={styles ? styles : { marginTop: 5, textAlign: "center" }}>
        Loading
      </span>
    </>
  );
};

export default SpinnerComponent;
